// extracted by mini-css-extract-plugin
export default {"statusBadge":"StatusBadge_statusBadge__k6AzU","small":"StatusBadge_small__HdVrf","medium":"StatusBadge_medium__ug+9s","large":"StatusBadge_large__r6Zwz"};